import React from "react";
import { getCurrentJwt } from "../../util/jwt/decryptToken";
import GridContainer from "components/Grid/GridContainer.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";

import CardBody from "components/Card/CardBody.jsx";
import { PulseLoader } from "react-spinners";

import withStyles from "@material-ui/core/styles/withStyles";
import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import Cookies from "universal-cookie";

import Iframe from "react-iframe";
import NavPills from "components/NavPills/NavPills.jsx";
import LoadingOverlay from "react-loading-overlay";
import { css } from "react-emotion";
import "assets/scss/styles.css";

const cookies = new Cookies();
// core components
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
  text-align: center;
  margin-top: 10px;
`;
class CustomerPortfolio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadData: "",
      url: "",
      selectedAppId: "",
      engineObjectId: "",
      isActive: true,
      height: "1000px"
    };
  }
  componentDidMount() {
    this.setState({ height: window.innerHeight + "px" });
    let id = this.props.appId;
    this.setState({
      selectedAppId: id
    });
    var obj = {
      method: "GET",
      headers: { Authorization: getCurrentJwt() }
    };
    fetch(
      process.env.REACT_APP_QLIK_API + "sheets?cookie=" +
        localStorage.getItem("cookie") +
        "&app_id=" +
        id,
      obj
    )
      .then(res => res.json())
      .then(
        result => {
          this.setState({
            sheetsData: result.sort((a, b) => (a.id > b.id) ? 1 : -1),
            loadData: "showTabs"
          });
        },
        error => {
        }
      );

    setTimeout(
      function() {
        this.setState({
          isActive: false
        });
      }.bind(this),
      1000
    );
  }

  getSheetData(engineObjectId) {
    cookies.remove("X-Qlik-Session", {
      path: "/",
      domain: process.env.REACT_APP_QLIKURL,
      httpOnly: true,
      secure: true
    });
    // this.setState({ loadSpinner: false });
    this.setState({
      loadData: "",
      url:
        "https://" +
        process.env.REACT_APP_QLIKURL +
        "/single/?appid=" +
        this.state.selectedAppId +
        "&sheet=" +
        engineObjectId +
        "&opt=currsel&select=clearall&qlikTicket=" +
        localStorage.getItem("ticket") +
        "&theme=datadelivers4.0"
    });

  }
  handleSimple = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  // myOnloadFunction() {
  //   const iframe = document.querySelector("#myId");
  //   iframe.onload = () => {
  //   };
  // }
  // var iframe = this.refs.iframe.getDOMNode();

  // //let iframe = ReactDOM.findDOMNode(this.refs.iframe);
  // //iframe.addEventListener("load", this.props.onLoad);
  // if (iframe.attachEvent) {
  //   iframe.attachEvent("onload", function() {
  //     alert("Local iframe is now loaded.(IE)");
  //   });
  // } else {
  //   iframe.onload = function() {
  //     alert("Local iframe is now loaded.(non-IE)");
  //   };
  // }

  showSheets() {
    let tabs = [];
    for (let i = 0; i < this.state.sheetsData.length; i++) {
      let url =
        "https://" +
        process.env.REACT_APP_QLIKURL +
        "/single/?appid=" +
        this.state.selectedAppId +
        "&sheet=" +
        this.state.sheetsData[i].engineObjectId +
        // "&opt=noselection&select=clearall&qlikTicket=" +
        "&opt=currsel%2Cctxmenu&select=clearall&qlikTicket=" +
        localStorage.getItem("ticket") +
        "&theme=datadelivers4.0";
      /*if('dc0df8ce-c87e-4746-a00e-d2c9ee4d7534' == JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('clientId'),'secretpass').toString(CryptoJS.enc.Utf8))){
        url = "https://know.cmp.io/cmp/sense/app/" 
        + this.state.selectedAppId +
        "/sheet/" + this.state.sheetsData[i].engineObjectId + "/state/analysis/options/clearselections"
      }*/
      //"https://know.cmp.io/cmp/sense/app/b72826ff-64aa-444e-b7d4-85fd76afc640/sheet/bce7219f-4de6-4011-8235-3a8c6db93483/state/analysis/options/currsel" style="border:none; height: 100%; width: 100%;"></iframe>
      tabs.push({
        tabButton: this.state.sheetsData[i].name,
        tabContent: (
          <Iframe
            url={url}
            width="100%"
            height="1000px"
            id="myId"
            display="initial"
            position="relative"
            allowFullScreen

            // ref="iframe"
            // onLoad={this.myOnloadFunction}
          />
        )
      });
    }
    // this.setState({ loadSpinner: false });
    return (
      <div>
        <NavPills color="warning" tabs={tabs} className="disable-scrollbars" />
      </div>
    );
  }
  render() {
    var partial;
    if (this.state.loadData === "showTabs") {
      partial = this.showSheets();
    }
    if (this.state.isActive === true) {
      return (
        <center>
          <GridContainer style={{width: "100%",display: "flex",height: "100vh", justifyContent: "center"}}>
            <div style={{ alignSelf: "center"}}>
              <i className="fa fa-spinner fa-spin" style={{ fontSize: "50px" }} />
            </div>
          </GridContainer>
        </center>)
    } else {
      return (
        <CardBody className="cardBodyMargin0">
          {/* <div className="sweet-loading">
                  <ClipLoader
                    className={override}
                    sizeUnit={"px"}
                    size={30}
                    color={"#123abc"}
                    loading={this.state.isActive}
                  />
                </div> */}
          {partial}
        </CardBody>
      );
    }
  }
}
export default withStyles(userProfileStyles)(CustomerPortfolio);



// WEBPACK FOOTER //
// ./src/views/Insights/CustomerPortfolio.jsx